import { call, put, takeEvery } from "redux-saga/effects";

// Redux action types
import {
  GET_HISTORY_LIST_ROUND,
  GET_RESULT_HISTORY,
  GET_HISTORY_LIST_CSR,
  SEND_CHAT_MESSAGE,
  SEND_PARTICIPANT_CHAT,
  GET_PARTICIPANT_HISTORY,
} from "./actionTypes";

// Action creators
import {
  getActivityLogRoundsSuccess,
  getActivityLogRoundsFail,
  getResultHistorySuccess,
  getResultHistoryFail,
  getActivityLogCsrSuccess,
  getActivityLogCsrFail,
  sendChatMessageSuccess,
  sendChatMessageFail,
  sendParticipantChatSuccess,
  sendParticipantChatFail,
  getparticipantHistorySuccess,
  getparticipantHistoryFail,
} from "./actions";

// Helper API call
import {
  getHistoryRounds,
  getResultHistory,
  getHistoryCsr,
  sendChatMessage,
  sendParticipantChat,
  getparticipantHistory,
} from "../../helpers/django_api_helper";

function* fetchActivityLogRounds(action) {
  try {
    const { id, user_id } = action.payload;
    console.log("[Saga] Fetching CSR Activity Log for User ID:", id, user_id);
    const response = yield call(getHistoryRounds, id, user_id);
    yield put(getActivityLogRoundsSuccess(response));
  } catch (error) {
    yield put(getActivityLogRoundsFail(error));
  }
}

function* fetchActivityLogCsr(action) {
  try {
    const { id } = action.payload;
    console.log("[Saga] Fetching CSR Activity Log for User ID:", id);

    const response = yield call(getHistoryCsr, id);

    console.log("[Saga] API Response received:", response);

    yield put(getActivityLogCsrSuccess(response));
  } catch (error) {
    console.error("[Saga] Error fetching CSR Activity Log:", error);
    yield put(getActivityLogCsrFail(error));
  }
}

///////////////////////////

function* fetchParticipantHistory(action) {
  try {
    const { id } = action.payload;
    console.log("[Saga] Fetching CSR Activity Log for User ID:", id);

    const response = yield call(getparticipantHistory, id);

    console.log("[Saga] API Response received:", response);

    yield put(getparticipantHistorySuccess(response));
  } catch (error) {
    console.error("[Saga] Error fetching CSR Activity Log:", error);
    yield put(getparticipantHistoryFail(error));
  }
}
/////////////////////////
function* fetchActivityLogResult(action) {
  try {
    const { id, participantId, scheme_id } = action.payload; // Destructure id and type from payload
    const response = yield call(getResultHistory, id, participantId, scheme_id); // Pass both id and type to the API call
    // console.log("SAGAAAAAAAA",response)
    yield put(getResultHistorySuccess(response)); // Dispatch success with the response
  } catch (error) {
    yield put(getResultHistoryFail(error)); // Dispatch failure if error occurs
  }
}
function* handleSendChatMessage(action) {
  try {
    console.log("[Saga] Sending chat message:", action.payload);
    const response = yield call(sendChatMessage, action.payload); // calls your API
    yield put(sendChatMessageSuccess(response)); // dispatch success
  } catch (error) {
    yield put(sendChatMessageFail(error));
  }
}

function* handleSendParticipantChat(action) {
  try {
    console.log("[Saga] Sending chat message:", action.payload);
    const response = yield call(sendParticipantChat, action.payload); // calls your API
    yield put(sendParticipantChatSuccess(response)); // dispatch success
  } catch (error) {
    yield put(sendParticipantChatFail(error));
  }
}
function* RoundsHistorySaga() {
  yield takeEvery(GET_HISTORY_LIST_ROUND, fetchActivityLogRounds); // Watch for GET_HISTORY_LIST action
  yield takeEvery(GET_RESULT_HISTORY, fetchActivityLogResult);
  yield takeEvery(GET_HISTORY_LIST_CSR, fetchActivityLogCsr);
  yield takeEvery(SEND_CHAT_MESSAGE, handleSendChatMessage);
  yield takeEvery(SEND_PARTICIPANT_CHAT, handleSendParticipantChat);
  yield takeEvery(GET_PARTICIPANT_HISTORY, fetchParticipantHistory);
}

export default RoundsHistorySaga;
